export default {
    userGroups: {
        admin: "admin",
        viewer: "viewer",
        editor: "editor",
        support: "support",
    }
};
